import { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, EffectFade } from 'swiper/modules'
import Icon from 'components/shared/Icon'
import { Image } from 'components/shared/Image'
import { useResolutions } from 'store/resolutions'
import { GallerySliderModal } from './components/GallerySliderModal'
import {
    GallerySliderWrapper,
    MobileTrigger,
    MobileTriggerIcon,
} from './GallerySlider.styles'
import { GallerySliderProps } from './GallerySlider.types'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'

export const GallerySlider = ({
    images,
    alt,
    roomName,
    testPrefix,
}: GallerySliderProps) => {
    const { isTablet } = useResolutions()

    const [isModalOpened, setIsModalOpened] = useState(false)

    // preview images limited to 12 - maximum number of pagination elements possible to display as expected
    // - full list of images is visible on modal
    const previewImages = images.slice(0, 12)

    const handleModalOpen = () => setIsModalOpened(true)
    const handleModalClose = () => setIsModalOpened(false)

    return (
        <>
            <GallerySliderWrapper>
                {/* if images list is empty: */}
                {images.length === 0 && <Image height="100%" />}

                {/* if images list is not empty: */}
                {images.length !== 0 && isTablet ? (
                    // on mobile
                    <MobileTrigger onClick={handleModalOpen}>
                        <Image src={previewImages[0]} alt={alt} height="100%" />
                        <MobileTriggerIcon>
                            <Icon
                                variant="search"
                                color="grayscale_900"
                                rotation={0}
                                size={10}
                            />
                        </MobileTriggerIcon>
                    </MobileTrigger>
                ) : (
                    <Swiper // on desktop
                        navigation={{
                            prevEl: '.swiper-btn-prev',
                            nextEl: '.swiper-btn-next',
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        effect={'fade'}
                        modules={[Navigation, Pagination, EffectFade]}
                    >
                        {previewImages.map((imageUrl, index) => (
                            <SwiperSlide
                                key={index}
                                onClick={handleModalOpen}
                                data-testid={`${testPrefix}-gallery-trigger-zoom`}
                            >
                                <Image src={imageUrl} alt={alt} height="100%" />
                            </SwiperSlide>
                        ))}
                        <button
                            className="swiper-btn-prev"
                            data-testid={`${testPrefix}-gallery-btn-prev`}
                        >
                            <Icon
                                variant="chevron"
                                color="grayscale_900"
                                size={16}
                                rotation={90}
                            />
                        </button>
                        <button
                            className="swiper-btn-next"
                            data-testid={`${testPrefix}-gallery-btn-next`}
                        >
                            <Icon
                                variant="chevron"
                                color="grayscale_900"
                                size={16}
                                rotation={270}
                            />
                        </button>
                    </Swiper>
                )}
            </GallerySliderWrapper>

            {/* modal with detailed view */}
            {isModalOpened && (
                <GallerySliderModal
                    title={roomName}
                    images={images}
                    onClose={handleModalClose}
                />
            )}
        </>
    )
}
